import Navigator from "~/mixins/navigator/navigator";
import { formatHrefToPath, isVueRoute, isCurrentVueRoute } from "./helpers";

/**
 * Click handler used for generic <a> elements.
 * @param targetPath
 * @param clickEvent
 */
const handleTargetPathForAnchor = (targetPath, clickEvent) => {
  const formattedPath = formatHrefToPath(targetPath);
  if (isVueRoute(formattedPath)) {
    clickEvent.preventDefault();
    Navigator.navigateVuePath(formattedPath);
  }
  // Continue normal operations...
};

/**
 * Accepts click event, returns url that was clicked on.
 * @param clickEvent
 * @returns {undefined|string}
 */
const anchorClickTargetRouteResolver = (clickEvent) => {
  let { target } = clickEvent;
  let lastAnchorParent = null;

  // Traverse the parent elements until the container element is reached
  while (target && target !== this) {
    if (target.tagName === "A") {
      // Update the lastAnchorParent if the current element is an anchor tag
      lastAnchorParent = target;
    }
    target = target.parentNode;
  }
  if (!lastAnchorParent) return undefined;
  const url = new URL(lastAnchorParent.href, window.location.origin);
  return url.pathname;
};

/**
 * Redirects navigation from native anchor tags to vue router where needed.
 * @param clickEvent
 */

const arbitraryAnchorClickHandler = (clickEvent) => {
  const targetPath = anchorClickTargetRouteResolver(clickEvent);
  if (!targetPath) return;
  handleTargetPathForAnchor(targetPath, clickEvent);
};

export {
  isVueRoute,
  isCurrentVueRoute,
  formatHrefToPath,
  anchorClickTargetRouteResolver,
  arbitraryAnchorClickHandler,
  handleTargetPathForAnchor,
};
